/**
 * @flow
 * @relayHash bc8e94d5b157cc9ba309533a10e1662d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CurrencyUpdateInput = {|
  id: string,
  name: string,
  code: string,
|};
export type UpdateCurrencyMutationVariables = {|
  data: CurrencyUpdateInput
|};
export type UpdateCurrencyMutationResponse = {|
  +updateCurrency: {|
    +id: string
  |}
|};
export type UpdateCurrencyMutation = {|
  variables: UpdateCurrencyMutationVariables,
  response: UpdateCurrencyMutationResponse,
|};
*/


/*
mutation UpdateCurrencyMutation(
  $data: CurrencyUpdateInput!
) {
  updateCurrency(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "CurrencyUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateCurrency",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "CurrencyModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateCurrencyMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateCurrencyMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateCurrencyMutation",
    "id": null,
    "text": "mutation UpdateCurrencyMutation(\n  $data: CurrencyUpdateInput!\n) {\n  updateCurrency(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '75c1ab8c970d16a26b4388647b65a458';
module.exports = node;
